export function forgotPasswordMutationDefinition() {
  return {
    url: '/api/users/password.json',
    method: 'POST'
  };
}
